module.exports = __webpack_public_path__ + "img/news.08106540.svg";